import React, { useState } from "react";
import "./webinar-set-data-table.styles.scss";

import CustomButton from "../../commons/custom-button/custom-button.component";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import EmptyTableComponent from "../empty-component/empty-table-compontent";
import { getOldOrderHistory, getWebinars } from "../../../redux/clientdata/client.action";
import { createToken } from "../../../js/api/_azure-queue.data";
import { ClientServices } from "../../../redux/clientdata/client.services";
import ContentWell from "../../commons/content-well/content-well.component";
import stripHtml from "string-strip-html";
import Parser from "html-react-parser";
import removeStyleFromHTMLString from "../../../utilities/CommonUtilities";
import Moment from 'moment';

function WebinarTableComponent({
    title,
    filterOne,
    filterTwo,
    filterThree,
    filterFour,
    tableItemsOne,
    tableItemsTwo,
    categoriesOne,
    categoriesTwo,
    tableOneColumnWidth = "400px",
    tableTwoColumnWidth = "400px",
}) {
    const [tableColumnWidth, setTableColumnWidth] = useState(tableOneColumnWidth);
    const [tableNewColumnWidth, setTableNewColumnWidth] = useState("200");
    const [activeDisplay, setAtiveDisplay] = useState(filterOne);
    const [tableCategories, setTableCategories] = useState(categoriesOne);
    const [tableItems, setTableItems] = useState(tableItemsOne);

    const clientWebinarList = useSelector(({ client }) => client.webinarList);
    const clientOldWebinarList = useSelector(({ client }) => client.oldOnDemand);

    const history = useHistory();
    const dispatch = useDispatch();
    const userEmailData = useSelector(({ user }) => user.loggedin_user);//RK--Changed from Verified_Email to Loggedin_user
    const userMemberIdData = useSelector(({ cart }) => cart.impersonateMember);

    // console.clear();
    // console.log(userMemberIdData);
    React.useEffect(() => {
        dispatch(getWebinars(userMemberIdData.memberId));
        dispatch(getOldOrderHistory(userEmailData))
    }, []);

    const toggleDisplayOne = () => {
        setTableColumnWidth(tableOneColumnWidth);
        setAtiveDisplay(filterOne);
        setTableCategories(categoriesOne);
        setTableItems(tableItemsOne);
    };

    const toggleDisplayTwo = () => {
        setTableColumnWidth(tableTwoColumnWidth);
        setAtiveDisplay(filterTwo);
        setTableCategories(categoriesTwo);
        setTableItems(tableItemsTwo);
    };

    const toggleDisplayThree = () => {
        setTableColumnWidth(tableTwoColumnWidth);
        setAtiveDisplay(filterThree);
    };

    const toggleDisplayFour = () => {
        setTableColumnWidth(tableTwoColumnWidth);
        setAtiveDisplay(filterFour);
    }

    /*if (clientWebinarList.length === 0) {
        return (<EmptyTableComponent message={"You do not have purchase any on demand courses"}/>);
    }*/

    //TODO Implement download function
    // const onOpenVideo = async (courseName, webinarType) => {
    //     const token = await createToken();
    //     ClientServices.getOnDemandVideoURL(courseName, webinarType, token).then((url) => {
    //         history.push('/client/playback', url)
    //     })
    // };   

    const onOpenVideo = (url) => {
        // const token = await createToken();
        // ClientServices.getOnDemandVideoURL(courseName, webinarType, token).then((url) => {
        history.push('/client/playback', url)
        //})
    };

    let finalPreparedData = [...clientWebinarList, ...clientOldWebinarList];

    return (
        <div className="sofware-dual-set-data-table">
            <div className="trinity-container">
                <h2 className="d-lg-none">{title}</h2>
                {/*<div className="section-filters mt-3 mb-3">
                    <span className={`filter clickable ${activeDisplay === filterOne ? "bold" : ""}`}
                          onClick={toggleDisplayOne}>
                        {filterOne}
                    </span>
                    <span className="seperator ml-2 mr-2">|</span>
                    <span className={`filter clickable ${activeDisplay === filterTwo ? "bold" : ""}`}
                          onClick={toggleDisplayTwo}>
                        {filterTwo}
                    </span>
                    <span className="seperator ml-2 mr-2">|</span>
                    <span className={`filter clickable ${activeDisplay === filterThree ? "bold" : ""}`}
                          onClick={toggleDisplayThree}>
                        {filterThree}
                    </span>
                    <span className="seperator ml-2 mr-2">|</span>
                    <span className={`filter clickable ${activeDisplay === filterFour ? "bold" : ""}`}
                          onClick={toggleDisplayFour}>
                        {filterFour}
                    </span>
                </div>*/}
            </div>

            <div className="data-table-container">
                <div className="overflow-width-setter">
                    <div className="table-categories mb-3">
                        <div className="trinity-container d-flex fluid">
                            {tableCategories.map((category, i) => (
                                <h5
                                    key={category}
                                    style={i == 0 ? { width: tableColumnWidth } : { width: tableNewColumnWidth }}
                                    className="category column m-0"
                                >
                                    <span className="mr-2">{category}</span>
                                </h5>
                            ))}
                        </div>
                    </div>

                    {
                        finalPreparedData && (
                            <div className="trinity-container">
                                <div className="table-items">
                                    {
                                        finalPreparedData.length === 0
                                            ? <h3>No Records Available.</h3>
                                            : finalPreparedData.map((item, i) => {
                                                // { customer_id, data, software, edition, version, released, activated, maintenance }
                                                return (
                                                    <div key={Math.random() * 100 + i} className="table-item">
                                                        <div key={Math.random()} style={{ width: tableColumnWidth }}
                                                            className="column">
                                                            {item.CourseName}
                                                        </div>
                                                        {/*<div key={Math.random()} style={{width: tableColumnWidth}}
                                                             className="column">
                                                            <ContentWell content={removeStyleFromHTMLString(Parser(item.CourseDescription))}/>
                                                        </div>*/}
                                                        <div key={Math.random()} style={{ width: tableNewColumnWidth }}
                                                            className="column">
                                                            {item.CourseLength}
                                                        </div>
                                                        <div key={Math.random()} style={{ width: tableNewColumnWidth }}
                                                            className="column">
                                                            {item.OrderNumber}
                                                        </div>
                                                        <div key={Math.random()} style={{ width: tableNewColumnWidth }}
                                                            className="column">
                                                            {Moment(item.CompletedDate).format('MM/DD/YYYY')}
                                                        </div>
                                                        <div className="column"
                                                            onClick={() => onOpenVideo(item.Link)}>
                                                            {/* {<CustomButton btndisabled = {false} >Start Course</CustomButton>} */}
                                                            {item.IsExpire != undefined && item.IsExpire == true && <CustomButton btndisabled={true} >Not Available</CustomButton>}
                                                            {item.IsExpire != undefined && item.IsExpire == false && <CustomButton btndisabled={false} >Start Course</CustomButton>}
                                                        </div>
                                                    </div>
                                                );
                                            })
                                    }
                                </div>
                            </div>
                        )
                    }

                    {/* {
                        activeDisplay === filterTwo && clientWebinarList && (
                            <div className="trinity-container">
                                <div className="table-items">
                                    {
                                        clientWebinarList.filter(e => e.PaymentType === "Free").length === 0
                                            ? <h3>No Records Available.</h3>
                                            : clientWebinarList.filter(e => e.PaymentType === "Free").map((item, i) => {
                                                // { customer_id, data, software, edition, version, released, activated, maintenance }
                                                return (
                                                    <div key={Math.random() * 100 + i} className="table-item">
                                                        <div key={Math.random()} style={{width: tableColumnWidth}}
                                                             className="column">
                                                            {item.CourseName}
                                                        </div>
                                                        <div key={Math.random()} style={{width: tableColumnWidth}}
                                                             className="column">
                                                            <ContentWell content={removeStyleFromHTMLString(Parser(item.CourseDescription))}/>
                                                        </div>
                                                        <div key={Math.random()} style={{width: tableColumnWidth}}
                                                             className="column">
                                                            {item.CourseLength}
                                                        </div>
                                                        <div className="column"
                                                             onClick={() => onOpenVideo(item.CourseName, item.PaymentType)}>
                                                            <CustomButton>Start Course</CustomButton>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                    }
                                </div>
                            </div>
                        )
                    }

                    {
                        activeDisplay === filterThree && clientOldWebinarList && (
                            <div className="trinity-container">
                                <div className="table-items">
                                    {
                                        clientOldWebinarList.filter(e => e.PaymentType === "Paid").length === 0
                                            ? <h3>No Records Available.</h3>
                                            : clientOldWebinarList.filter(e => e.PaymentType === "Paid").map((item, i) => {
                                                // { customer_id, data, software, edition, version, released, activated, maintenance }
                                                return (
                                                    <div key={Math.random() * 100 + i} className="table-item">
                                                        <div key={Math.random()} style={{width: tableColumnWidth}}
                                                             className="column">
                                                            {item.CourseName}
                                                        </div>
                                                        <div key={Math.random()} style={{width: tableColumnWidth}}
                                                             className="column">
                                                            <ContentWell content={removeStyleFromHTMLString(Parser(item.CourseDescription))}/>
                                                        </div>
                                                        <div key={Math.random()} style={{width: tableColumnWidth}}
                                                             className="column">
                                                            {item.CourseLength}
                                                        </div>
                                                        <div className="column"
                                                             onClick={() => onOpenVideo(item.CourseName, item.PaymentType)}>
                                                            <CustomButton>Start Course</CustomButton>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                </div>
                            </div>
                        )
                    }

                    {
                        activeDisplay === filterFour && clientOldWebinarList && (
                            <div className="trinity-container">
                                <div className="table-items">
                                    {
                                        clientOldWebinarList.filter(e => e.PaymentType === "Free").length === 0
                                            ? <h3>No Records Available.</h3>
                                            : clientOldWebinarList.filter(e => e.PaymentType === "Free").map((item, i) => {
                                                // { customer_id, data, software, edition, version, released, activated, maintenance }
                                                return (
                                                    <div key={Math.random() * 100 + i} className="table-item">
                                                        <div key={Math.random()} style={{width: tableColumnWidth}}
                                                             className="column">
                                                            {item.CourseName}
                                                        </div>
                                                        <div key={Math.random()} style={{width: tableColumnWidth}}
                                                             className="column">
                                                            <ContentWell content={removeStyleFromHTMLString(Parser(item.CourseDescription))}/>
                                                        </div>
                                                        <div key={Math.random()} style={{width: tableColumnWidth}}
                                                             className="column">
                                                            {item.CourseLength}
                                                        </div>
                                                        <div className="column"
                                                             onClick={() => onOpenVideo(item.CourseName, item.PaymentType)}>
                                                            <CustomButton>Start Course</CustomButton>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                </div>
                            </div>
                        )
                    }*/}
                </div>
            </div>
        </div>
    );
}

export default WebinarTableComponent;
